import {getConfigItem, configConstants} from '@servicenow/ui-config';
import Ajv from 'ajv';

const {VALIDATE_SCHEMAS} = configConstants;
const validateSchemas = getConfigItem(VALIDATE_SCHEMAS);

let ajv;
if (validateSchemas) {
	ajv = new Ajv();
	ajv.addKeyword('fn', {
		validate: function validateFn(schema, data) {
			if (data instanceof Function) return true;

			if (data === undefined || data === null) return true;

			validateFn.errors = [
				{
					message: 'should be a function',
					params: {
						level: 'error'
					}
				}
			];
			return false;
		}
	});
	ajv.addKeyword('deprecated', {
		validate: function validateDeprecation(schema) {
			if (!schema) return true;

			const message = typeof schema === 'boolean' ? 'has been deprecated' : schema;
			validateDeprecation.errors = [
				{
					message,
					params: {
						level: 'warn'
					}
				}
			];

			return false;
		}
	});
} else {
	ajv = {compile: () => () => true};
}

export default ajv;
